import { Box, FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectProps, styled } from '@mui/material';
import React from 'react';
import TriangleDown from '../icons/TriangleDown';

export type Options = {
  value: any;
  text: string | undefined;
};

export interface DropdownItem<T> {
  value: T;
  text: string | undefined;
}

export interface AccordionModelMenuItem<T, U> {
  text: string;
  value: T;
  extendValue?: Array<DropdownItem<U>>;
}

export interface Props extends SelectProps {
  options: Array<Options>;
  helperText?: string;
  placeholder?: string;
  width?: React.CSSProperties['width'];
  isError?: boolean;
  handleClick?: (e: any) => void;
}

const SelectInput = styled(OutlinedInput)(({ theme }) => ({
  borderRadius: 8,
  background: 'white',
  '& fieldset': {
    borderColor: '#6C708C',
  },
  '& .MuiInputBase-input': {
    minHeight: `0 !important`,
    fontSize: 20,
    padding: '8px 26px 8px 12px',
  },
}));

const TriangleDownIcon = styled(TriangleDown)(() => ({
  color: '#BB5E00',
  fill: '#BB5E00',
}));

export default function YatungSelectColor({
  helperText,
  width,
  isError,
  options,
  placeholder = '請選擇 - - -',
  ...props
}: Props) {
  return (
    <FormControl sx={{ width: width ? width : 180 }}>
      {helperText && <InputLabel>{helperText}</InputLabel>}
      <Select
        defaultValue={0}
        input={<SelectInput label={helperText} />}
        IconComponent={TriangleDownIcon}
        {...props}
        sx={{
          ...props.sx,
          ...(width ? { width } : {}),
          border: isError ? '1px red solid' : {},
        }}
      >
        <MenuItem disabled value={0}>
          {placeholder}
        </MenuItem>
        {options?.map((option: Options, index) => (
          <MenuItem key={index} value={option.value}>
            <Box
              sx={{
                width: '20px',
                height: '20px',
                backgroundColor: option.text,
                borderRadius: '50%',
              }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
